function MedicalHistoryPdfContent({ files }) {
const pageStyle = {
    width: "100%",
    minHeight: "29.7cm", 
    height: "29.7cm",    
    padding: "1cm",      
    paddingTop: "2cm",   
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start", 
    position: "relative",
  };

  const pdfImageStyle = {
    maxWidth: "100%",
    maxHeight: "calc(100% - 4cm)", // Account for padding
    width: "auto",
    height: "auto",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  };

  return (
    <div id="medical-pdf-content" style={{ display: "block" }}>
      {files.map((file, index) => (
        <div key={index} style={pageStyle}>
        <img
          src={URL.createObjectURL(file)}
          alt={file.name}
          style={pdfImageStyle}
        />
      </div>
      ))}
    </div>
  );
}


export default MedicalHistoryPdfContent;